import React from 'react';
import classNames from 'classnames';
import { makeStyles } from '~/UIKit/Style';
import uscLogo from '../../../Assets/Images/usc_logo_dark.png';
import { WHITE } from '../../../Constants/Colors.constants';

const useStyles = makeStyles((theme) => ({
  rootLoginCustomHeader: {
    height: 70,
    position: 'relative',
    top: 0,
    left: 0,
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1,
    backgroundColor: WHITE,
    boxShadow: '0px 5px 5px rgb(0 0 0 / 9%)',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      height: 70,
    },
  },
  logoLoginCustomHeader: {
    maxHeight: 24,
    [theme.breakpoints.down('md')]: {
      height: 20,
    },
  },
  uscLogo: {
    [theme.breakpoints.down('md')]: {
      marginLeft: 0,
    },
  },
}));

export const LoginCustomHeader = () => {
  const { classes } = useStyles();
  return (
    <div className={classes.rootLoginCustomHeader}>
      <img
        src={uscLogo}
        className={classNames(classes.logoLoginCustomHeader, classes.uscLogo)}
        alt="USC Logo"
      />
    </div>
  );
};
